import { isFinlandLocationStrict, isRemoteRegionalScopeForJobCard } from '../geocoding/is-finland-location';

/**
 * Display / lookup ordering for JobCrawls (Finnish market): explicit Finland first,
 * then broad regional remote scopes (Europe, EMEA, …), then other locations.
 * Stable within the same tier (preserves feed order).
 */
export function marketplaceLocationPriorityTier(raw: string): number {
  const s = (raw || '').trim();
  if (!s) return 99;
  if (isFinlandLocationStrict(s)) return 0;
  if (isRemoteRegionalScopeForJobCard(s)) return 1;
  return 2;
}

export function compareLocationsForMarketplacePriority(a: string, b: string): number {
  return marketplaceLocationPriorityTier(a) - marketplaceLocationPriorityTier(b);
}

export function sortLocationsByMarketplacePriority(locations: string[]): string[] {
  if (locations.length <= 1) return [...locations];
  return locations
    .map((loc, index) => ({ loc, index }))
    .sort((x, y) => {
      const c = compareLocationsForMarketplacePriority(x.loc, y.loc);
      if (c !== 0) return c;
      return x.index - y.index;
    })
    .map((x) => x.loc);
}
